import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { useUserHasAdministrationRole } from '../../hooks/use-user-role';
import { useEnablePhoneNumberCapture } from '../../feature-flags/hooks/use-enable-phone-number-capture';
import { usePhoneNumberCaptureModalDismissed, useUserSettingsReady } from '../../hooks/use-user-setting';

export const useShouldShowPhoneCapture = () => {
  const isFeatureEnabled = useEnablePhoneNumberCapture();
  const hasAdminRole = useUserHasAdministrationRole();
  const sellerPhoneNumber = useSelector(Global.selectSellerPhoneNumber);
  const hasDismissed = usePhoneNumberCaptureModalDismissed();
  const userSettingsReady = useUserSettingsReady();
  const buyNowSetting = useSelector(Global.selectSellerBuyNowSetting);
  const isBuyNowFlowActive = buyNowSetting.optedInToBuyNow && !buyNowSetting.isBuyNowFlowCompleted;

  if (isBuyNowFlowActive) {
    return false;
  }

  if (!userSettingsReady) {
    return false;
  }

  if (!isFeatureEnabled || !hasAdminRole) {
    return false;
  }

  const hasPhoneNumber = Boolean(sellerPhoneNumber);
  if (hasPhoneNumber) {
    return false;
  }

  return !hasDismissed;
};
